module.exports = __webpack_public_path__ + "img/no_datal.b51fc7fb.svg";